/** OpenStreetMap raster tiles — primary labels in Hebrew across Israel (entrepreneurs map style). */
export const HEBREW_OSM_BASEMAP = {
  url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  subdomains: 'abc',
} as const;

/** Esri World Imagery — interim aerial until GovMap API token (v2). */
export const ESRI_WORLD_IMAGERY = {
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
  attribution:
    'Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community',
} as const;

export type MapBasemapKind = 'streets' | 'aerial';

export function resolveBasemap(kind: MapBasemapKind) {
  return kind === 'aerial' ? ESRI_WORLD_IMAGERY : HEBREW_OSM_BASEMAP;
}

/** Default basemap when /api/map/config is unavailable. */
export const FALLBACK_BASEMAP = HEBREW_OSM_BASEMAP;

export function MapClickModeIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden>
      <circle cx="12" cy="12" r="2.5" fill="currentColor" />
      <path
        d="M12 3v3M12 18v3M3 12h3M18 12h3"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function MapDrawModeIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden>
      <path
        d="M5 10.5 9.5 6 18 14.5 13.5 19 5 10.5Z"
        stroke="currentColor"
        strokeWidth="1.75"
        fill="none"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 19 16.5 16"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function MapSizeIcon({ expanded }: { expanded: boolean }) {
  if (expanded) {
    return (
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden>
        <path
          d="M9 3H3v6M15 3h6v6M9 21H3v-6M15 21h6v-6"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden>
      <path
        d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
